import { useContext } from 'react';

import { PasswordPoliciesContext } from '../contexts';
import { PasswordPoliciesContextProps } from '../contexts/types';

export function usePasswordPolicies(): PasswordPoliciesContextProps {
    return useContext(PasswordPoliciesContext);
}
